<template>
  <div class="p-changePlan">
    <div class="c-grid">
      <div class="c-grid__items">
        <div class="c-graphStatus__item c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__12">
          <div class="p-box">
            <form v-if="!loading && changeable_plans" class="p-changePlan__form" @submit.prevent="onSubmit">
              <div class="p-changePlan__form__main">
                <div class="p-box__body">
                  <h3 class="p-box__title">{{ $t('pages.CompaniesChangePlan.selectPlan') }}</h3>
                  <div class="p-changePlan__form__body">
                    <p class="c-formLabel">{{ $t('pages.CompaniesChangePlan.selectablePlan') }}</p>
                    <div class="p-changePlan__form__body__select">
                      <div class="c-select">
                        <Select v-model="plan_id" :options="changeablePlansOptions" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="selectedPlan" class="p-changePlan__form__price-board">
                <h3 class="p-changePlan__form__price-board__title">{{ $t('pages.CompaniesChangePlan.paymentDetails') }}</h3>
                <div class="p-changePlan__form__price-board__price">
                  <p>{{ $t('pages.CompaniesChangePlan.numberOfAvailableStores') }}：</p>
                  <p class="u-fwB">{{ $tc('labels.storesCount', selectedPlan.attributes.max_store_count) }}</p>
                </div>
                <div class="p-changePlan__form__price-board__price">
                  <p>{{ $t('pages.CompaniesChangePlan.changePlanPrice') }}（{{ $t('labels.monthlyDiscount', { number: changeable_plans_meta.billing_month }) }}）:</p>
                  <p class="u-fwB">{{ $t('labels.currency.yen', { number: selectedPlan.attributes.annual_cost_amount.toLocaleString() }) }}</p>
                </div>
                <div class="p-changePlan__form__price-board__price">
                  <p>{{ $t('labels.tax') }}：</p>
                  <p class="u-fwB">{{ $t('labels.currency.yen', { number: selectedPlan.attributes.annual_cost_tax_amount.toLocaleString() }) }}</p>
                </div>
                <div class="p-changePlan__form__price-board__bottom">
                  <div class="p-changePlan__form__price-board__bottom__total-price">
                    <p class="u-fwB">{{ $t('labels.totalBilledAmount') }}</p>
                    <p class="u-fwB u-colorPrimary">{{ $t('labels.currency.yen', { number: selectedPlan.attributes.total_cost_amount.toLocaleString() }) }}</p>
                  </div>
                  <p class="u-taL">{{ $t('pages.CompaniesChangePlan.billDescription') }}</p>
                  <p class="c-checkbox__item p-changePlan__form__price-board__bottom__checkbox u-pad0">
                    <input id="checkbox1" v-model="isAgree" class="c-checkbox__input" type="checkbox">
                    <i18n-t class="c-checkbox__label p-changePlan__form__price-board__bottom__checkbox__agreement" keypath="pages.CompaniesChangePlan.agreeTerms" for="checkbox1" tag="label">
                      <span class="c-links__item u-pad0">
                        <a :href="servicePrivacyUrl" target="_blank">{{ $t('labels.terms') }}</a>
                      </span>
                    </i18n-t>
                  </p>
                  <button :disabled="!validButton()" :class="submitBtnStyle">
                    {{ $t('pages.CompaniesChangePlan.apply') }}
                  </button>
                </div>
              </div>
            </form>
          </div>
          <Loading v-show="loading" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select from '../components/Select'
import ImgIconQuestion from '../../../images/common/icon_question.svg'
import {mapActions, mapGetters, mapState} from 'vuex'
import Loading from '../components/Loading'
import { allServiceUrlConst } from '../modules/serviceUrlConst'

export default {
  name: 'CompaniesChangePlan',
  comments: {
    Select,
  },
  components: {Loading, Select},
  data() {
    return {
      isAgree: false,
      plan_id: null,
    }
  },
  computed: {
    ...mapState({
      changeable_plans: state => state.companiesChangeablePlans.data.data,
      changeable_plans_meta: state => state.companiesChangeablePlans.data.meta,
      loading: state => state.companiesChangeablePlans.loading || state.companiesAvailablePlan.loading,
    }),
    ...mapGetters({
      useServiceName: 'companiesCompany/useServiceName',
    }),
    currentCompanyUuid() {
      return this.$route.params.company_uuid
    },
    currentPlanId() {
      return this.changeable_plans_meta.current_plan_id
    },
    selectedPlan() {
      return this.changeable_plans.find(v => v.id === this.plan_id)
    },
    imgIconQuestion() {
      return ImgIconQuestion
    },
    submitBtnStyle() {
      return {
        'c-button__item p-changePlan__form__price-board__bottom__submit-button': true,
        'c-button__item--outline-primary': this.validButton(),
        'c-button__item--disabled': !this.validButton(),
      }
    },
    changeablePlansOptions() {
      const obj = {}
      this.changeable_plans.map(v => {
        obj[this.formatOption(v)] = v.id
      })
      return obj
    },
    servicePrivacyUrl() {
      return allServiceUrlConst[this.useServiceName].privacy
    }
  },
  async created() {
    await this.readChangeablePlans(this.currentCompanyUuid)
    this.plan_id = this.currentPlanId
  },
  methods: {
    ...mapActions({
      readCompany: 'companiesCompany/readCompany',
      readChangeablePlans: 'companiesChangeablePlans/readChangeablePlans',
      writeAvailablePlan: 'companiesAvailablePlan/writeAvailablePlan',
    }),
    formatOption(plan) {
      return plan.id != this.currentPlanId
        ? this.formatPlanKind(plan)
        : this.formatPlanKind(plan) + this.$t('labels.current')
    },
    formatPlanKind(plan) {
      switch (plan.attributes.kind){
      case 'entry':
        return this.$t('labels.plan.entry')
      case 'small':
        return this.$t('labels.plan.small')
      case 'lite':
        return this.$t('labels.plan.lite')
      case 'basic':
        return this.$t('labels.plan.basic')
      }
    },
    notCurrentPlanId() {
      return this.plan_id != this.currentPlanId
    },
    validButton() {
      return this.isAgree && this.notCurrentPlanId()
    },
    async onSubmit() {
      const isSuccess = await this.writeAvailablePlan({ company_uuid :this.currentCompanyUuid, plan_id: this.plan_id, update_kind: 'plan_change' })
      if (isSuccess) {
        this.readCompany(this.currentCompanyUuid)
        this.$router.push({ name: 'PaymentSetting', params: { company_uuid: this.currentCompanyUuid }})
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.p-changePlan {
  margin: 0 124px;
  &__form {
    display: flex;
    justify-content: space-between;
    &__main {
      width: 596px;
      &__store-amounts {
        border-bottom: 1px solid #E4E7EB;
        box-sizing: border-box;
      }
    }
    &__price-board {
      width: 400px;
      margin: 32px 32px 779px;
      padding: 24px;
      border: 1px solid #E4E7EB;
      border-radius: 4px;
      font-size: 14px;
      &__title {
        font-size: 14px;
      }
      &__bottom {
        font-size: 12px;
        text-align: center;
        border-top: 1px solid #E4E7EB;
        &__total-price {
          display: flex;
          justify-content: space-between;
          margin: 24px auto;
          font-size: 18px;
        }
        &__submit-button {
          margin: 16px auto;
        }
        &__checkbox {
          margin-top: 24px;
          margin-bottom: 22px;
          &__agreement {
            font-size: 12px;
            span {
              font-size: 12px !important;
            }
          }
        }
      }
      &__price {
        display: flex;
        justify-content: space-between;
        margin: 24px auto;
      }
    }
    &__body {
      padding-top: 32px;
      padding-bottom: 32px;
      &--border {
        border-bottom: 1px solid #E4E7EB;
      }
      &__form {
        margin-bottom: 32px;
      }
      &__description {
        font-weight: normal;
        font-size: 10px;
      }
      &__select {
        display: flex;
        align-items: flex-end;
        margin-bottom: 16px;
      }
    }
  }
}
</style>
